import React from 'react';
import { StaggerContainer, StaggerItem } from './AnimatedSection';
import { SpotlightCard, TiltCard } from './Animations';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export interface CardProps {
  title: string;
  description?: string;
  to?: string;
  icon?: React.ReactNode;
  tag?: React.ReactNode;
}
interface CardGridProps {
  cards: CardProps[];
  columns?: 2 | 3 | 4;
}
export function CardGrid({
  cards,
  columns = 3
}: CardGridProps) {
  const gridCols = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  };
  return <StaggerContainer className={`grid gap-6 ${gridCols[columns]}`} data-id="element-148">
      {cards.map((card, idx) => <StaggerItem key={idx} data-id="element-149">
          {card.to ? <Link to={card.to} className="block h-full group" data-id="element-150">
              <CardContent {...card} data-id="element-151" />
            </Link> : <div className="h-full" data-id="element-152">
              <CardContent {...card} data-id="element-153" />
            </div>}
        </StaggerItem>)}
    </StaggerContainer>;
}
function CardContent({
  title,
  description,
  to,
  icon,
  tag
}: CardProps) {
  return <TiltCard className="h-full" data-id="element-154">
      <SpotlightCard className="h-full p-8 flex flex-col" data-id="element-155">
        {tag && <span className="text-xs font-medium text-picus-accent uppercase tracking-wider mb-4 block" data-id="element-156">
            {tag}
          </span>}
        {icon && <div className="mb-6 text-picus-accent" data-id="element-157">{icon}</div>}
        <h3 className="text-xl font-serif mb-3 text-picus-text" data-id="element-158">{title}</h3>
        {description && <p className="text-picus-muted text-sm leading-relaxed flex-grow" data-id="element-159">
            {description}
          </p>}
        {to && <div className="mt-6 flex items-center text-sm font-medium text-picus-accent group-hover:text-picus-accentHover transition-colors" data-id="element-160">
            Learn more{' '}
            <ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-161" />
          </div>}
      </SpotlightCard>
    </TiltCard>;
}